export default __webpack_public_path__ + "2d627b8e052fbe01014488ef47aaabe1.png";